<template>
  <div class="daBG">
    <div class="navHeader">
      <div class="list" :class="nav==1?'active':''" @click="router(1)"><span class="heng" v-if="nav==1"></span>业务信息</div>
      <div class="list" :class="nav==2?'active':''" @click="router(2)"><span class="heng" v-if="nav==2"></span>审批历史</div>
      <div class="list" :class="nav==3?'active':''" @click="router(3)"><span class="heng" v-if="nav==3"></span>附件管理</div>
    </div>
  </div>
</template>

<script>
  export default {
  	components: {

  	},
    props:{
      nav:'',
    },
  	data() {
  		return {

  		}
  	},
  	created() {

  	},
    methods:{
      router(index){
        this.$emit('tabClick',index)
      }
    }
  }
</script>

<style lang="less">
  .navHeader{
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    justify-content:space-between;
    height: 60px;
    line-height: 60px;
    margin-top: 20px;
    .list{
      font-size: 28px;
      color: #666666;
      position: relative;
      .heng{
        width: 60px;
        height: 4px;
        background: #438cff;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }
    .active{
      color: #1890ff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/navHeader.vue